import { VaultDetailProvider } from 'context/vault-detail-context';
import { withAuth } from 'hocs/auth/with-auth';
import { AlbumViewMode } from './album-view-mode';

// Owner-facing "Memories" view (/vaults/:id/memories/view). Reuses the album
// view-mode UI but shows every memory in the vault on the left panel.
const MemoriesViewScreenInner = () => (
  <VaultDetailProvider>
    <AlbumViewMode allMemories />
  </VaultDetailProvider>
);

const MemoriesViewScreen = withAuth(MemoriesViewScreenInner);

export { MemoriesViewScreen };
